import { passkeyInterstitialViewStringsDefaultFabric } from "../passkey-interstitial/fabric/passkey-interstitial-view-strings-fabric";

// Fabric strings for different views in the Login flow
export const loginStringsFabric = {
  passkeyInterstitialViewStrings: passkeyInterstitialViewStringsDefaultFabric,
};
